import React from 'react';

interface FormFooterProps {
  actions: React.ReactNode;
  footerText?: React.ReactNode;
  footerBottom?: React.ReactNode;
}

const FormFooter: React.FC<FormFooterProps> = ({
  actions,
  footerText,
  footerBottom,
}) => (
  <div className="login-form__footer">
    <div className="login-form__actions">{actions}</div>
    {footerText && <div className="login-form__footer-text">{footerText}</div>}
    {footerBottom && footerBottom}
  </div>
);

export default FormFooter;
